import React from "react";

export const ApplyTCMP: React.FC = () => {
  return <>please paste html here</>;
};
